import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-copyright">
                    © 2025 Quokka LTD.
                </div>
                <div className="footer-links">
                    <Link to="/privacy-policy" className="footer-link">Privacy policy</Link>
                    <Link to="/terms-of-service" className="footer-link">Terms of service</Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer; 